import Fab from '@mui/material/Fab';
import React, { ReactNode } from 'react';
import Icon from '@mui/material/Icon';

export interface IFloatingActionButtonProps {
    onClick ?: (event : React.MouseEvent<HTMLElement, MouseEvent>) => void;

    id ?: string;
    value ?: string | number | Array<string>;
    size ?: 'small' | 'medium' | 'large';
    color ?: 'inherit' | 'primary' | 'secondary' | 'default';
    className ?: string;
    children ?: ReactNode;
    disabled ?: boolean;
}

const FloatingActionButton = (props : IFloatingActionButtonProps) : React.ReactElement => {
    const {
        onClick,
        id,
        value,
        size,
        color,
        disabled,
        className,
        children = <Icon>add</Icon>,
    } = props;

    return (
        <Fab
            id={id}
            value={value}
            // Disabled color option and harcoded background color to yellow through 'bcy' style
            color={color}
            disabled={disabled}
            size={size}
            onClick={onClick}
            className={`cpd bcy ${size === 'small' ? 'pl5 pr5' : ''} ${disabled ? 'bcg3' : 'bca1'} ${className}`}>
            {children}
        </Fab>
    );
};

export default FloatingActionButton;